<template>
  <d2-container>
    <template slot="header">
      <el-input
        clearable
        @keyup.enter.native="getSearch(null)"
        style="width: 200px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入用户id"
        size="small"
        v-model="listQuery.accountId"
      ></el-input>
      <el-input
        clearable
        @keyup.enter.native="getSearch(null)"
        style="width: 220px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入信息表单id"
        size="small"
        v-model="listQuery.infoTableId"
      ></el-input>
      <el-select
        class="filter-item"
        v-model="listQuery.status"
        placeholder="请选择状态"
        size="small"
        style="margin-right: 20px"
        clearable
      >
        <el-option
          v-for="item in isStatusList"
          :key="item.index"
          :label="item.label"
          :value="item.index"
        ></el-option>
      </el-select>
      <el-button
        @click="getSearch(null)"
        class="filter-item"
        type="primary"
        icon="search"
        size="small"
        v-debounce="debounceClick"
      >搜索</el-button>
    </template>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="cardData"
      @expand-change="getFacilityList"
      ref="table"
      row-key="id"
    >
      <!-- @mouseenter="mouseEnter('Dev')"
      @mouseleave="mouseLeave('Dev')"-->
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form
            label-position="left"
            inline
            class="demo-table-expand"
            v-for="(item, index) in props.row.orderItems"
            :label="item.name"
            :key="index"
          >
            <el-descriptions style="padding: 20px;" :column="2" size="medium">
              <template slot="title">
                <span>内容详情{{index+1}}</span>
              </template>
              <el-descriptions-item label="文字内容">{{props.row.orderItems[index].textContent}}</el-descriptions-item>
              <el-descriptions-item label="图片内容">
                <span v-for="(item,index2) in props.row.orderItems[index].imgContent" :key="index2">
                  <el-popover placement="left" trigger="click" width="400">
                    <img :src="item" width="400px" />
                    <img
                      slot="reference"
                      :src="item"
                      :alt="item"
                      style="max-height: 80px;max-width: 80px; padding: 5px"
                    />
                  </el-popover>
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="视频内容" class="videoContents">
                <div
                  class="demo"
                  v-for="(item,index2) in props.row.orderItems[index].videoContent"
                  :key="index2"
                >
                  <video-player
                    class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="props.row.orderItems[index].arrList[index2]"
                  ></video-player>
                </div>
              </el-descriptions-item>
            </el-descriptions>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户id">
        <template slot-scope="scope">
          <span @click="getUser(scope.row.accountId)" class="user">{{ scope.row.accountId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="信息表单id">
        <template slot-scope="scope">
          <span>{{ scope.row.infoTableId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="图片内容">
        <template slot-scope="scope">
          <span v-for="(item,index) in scope.row.imgContent" :key="index">
            <el-popover placement="left" trigger="click" width="400">
              <img :src="item" width="400px" />
              <img
                slot="reference"
                :src="item"
                :alt="item"
                style="max-height: 70px;max-width: 70px; padding: 5px"
              />
            </el-popover>
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="文字内容">
        <template slot-scope="scope">
          <span>{{ scope.row.textContent }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <span>{{ scope.row.status == 0 ? '待审核' : scope.row.status == 1 ? '通过' : '未通过' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="120">
        <template slot-scope="scope">
          <el-button
            size="small"
            v-permission:function="['loveFormReivew:btn_record']"
            type="primary"
            @click="auditRecord(scope.row.id)"
            style="margin-top: 10px;"
            :disabled="scope.row.status == 1 || scope.row.status == 2"
          >审核</el-button>
          <!-- <el-button
            size="small"
            type="danger"
            @click="delCard(scope.row.id)"
            style="margin-top: 10px;"
          >删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="width:500px"
      ></el-pagination>
    </template>
    <el-dialog title="记录审核" :visible.sync="dialogFormVisible" width="400px" center>
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="审核状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">未通过</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button type="primary" @click="sureData('form')">确 定</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  getRecordList,
  getRecordAudit,
  getRecordDetail
} from '@/api/demo/loveCounselor/index'
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
export default {
  name: 'loveFormReivew',
  computed: {
    ...mapGetters(['elements'])
  },
  components: {
    videoPlayer
  },
  data () {
    return {
      loveFormReivew_btn_record: false,
      tableKey: 0,
      listQuery: {
        accountId: '',
        infoTableId: '',
        status: '',
        currentPage: 1,
        pageSize: 20
      },
      isStatusList: [
        {
          index: 0,
          label: '待审核'
        },
        {
          index: 1,
          label: '通过'
        },
        {
          index: 2,
          label: '未通过'
        }
      ],
      cardData: [], // 表格数据
      total: null,
      dialogStatus: '',
      // textMap: {
      //   update: "编辑",
      //   create: "创建"
      // },
      dialogFormVisible: false, // 审核弹窗
      form: {
        status: '', // 审核状态
        id: '' // 记录id
      },
      rules: {
        status: [
          { required: true, message: '请选择审核状态', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    $route (to, from) {
      this.getSearch()
    }
  },
  created () {},
  mounted () {
    this.getSearch(null)
    // this. scrollDevInfoTabledata()
  },
  methods: {
    debounceClick () {
      console.log('2秒内点击无数次，都只会触发一次')
    },
    // scrollDevInfoTabledata() {
    //     // this.devInfo_tabledata.push(this.deviceData[0]);
    //     this.cardData.shift();
    //     if (this.cardData.length < 6) {
    //     }
    //     this.devTimer = setTimeout(this.scrollDevInfoTabledata, 3000)
    // },
    // //鼠标进入表格暂停
    // mouseEnter(label){
    //     if(label === 'Dev'){
    //       clearTimeout(this.devTimer);
    //       this.devTimer = null;}
    // },
    //   //鼠标离开表格开始轮播
    // mouseLeave(label){
    //     if(label === 'Dev'){
    //       this.devTimer = setTimeout(this.scrollDevInfoTabledata,3000);}
    // },
    // 搜索条件
    getSearch (val) {
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      getRecordList(this.listQuery).then(res => {
        this.listLoading = true
        this.cardData = res.records
        res.records.forEach((item, index) => {
          if (item.imgContent) {
            item.imgContent = item.imgContent.split(',')
          }
          if (item.videoContent) {
            // let key11 = "arrList";
            // let value11 = [];
            // res.records[index][key11] = value11;
            // item.videoContent = item.videoContent.split(",");
          }
        })

        // 给每行数据强制追加一个数据项
        res.records.map(item => {
          item.orderItems = []
        })
        this.total = parseInt(res.total)
        this.listLoading = false
      })
    },
    // 添加
    getAdd () {
      this.$router.push({
        path: '/demo/loveCounselor/addLoveCoun'
      })
    },
    // 编辑
    auditRecord (id) {
      this.dialogFormVisible = true
      this.form.id = id
    },
    getFacilityList (row, expandedRows) {
      let that = this
      if (expandedRows.length !== 0) {
        getRecordDetail(row.id).then(res => {
          that.listLoading = true
          const tables = that.cardData
          tables.forEach((item, index) => {
            if (item.id === row.id) {
              item['orderItems'] = res
              item['orderItems'].forEach((items, index) => {
                if (items.imgContent) {
                  items.imgContent = items.imgContent.split(',')
                }
                if (items.videoContent) {
                  let key11 = 'arrList'
                  let value11 = []
                  item['orderItems'][index][key11] = value11
                  items.videoContent = items.videoContent.split(',')
                }
              })
              for (let index = 0; index < item['orderItems'].length; index++) {
                if (item['orderItems'][index].videoContent) {
                  for (
                    let i = 0;
                    i < item['orderItems'][index].videoContent.length;
                    i++
                  ) {
                    let arr = {
                      playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
                      autoplay: false, // 如果为true,浏览器准备好时开始回放。
                      muted: false, // 默认情况下将会消除任何音频。
                      loop: false, // 是否视频一结束就重新开始。
                      preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                      language: 'zh-CN',
                      aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                      fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                      sources: [
                        {
                          type: 'video/mp4', // 类型
                          src: item['orderItems'][index].videoContent[i] // url地址
                        }
                      ],
                      poster: '', // 封面地址
                      notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                      controlBar: {
                        timeDivider: true, // 当前时间和持续时间的分隔符
                        durationDisplay: true, // 显示持续时间
                        remainingTimeDisplay: false, // 是否显示剩余时间功能
                        fullscreenToggle: true // 是否显示全屏按钮
                      }
                    }
                    item['orderItems'][index].arrList.push(arr)
                  }
                }
              }
            }
          })
          that.cardData = JSON.parse(JSON.stringify(tables))
          console.log('that.cardData', that.cardData)
        })
      } else {
      }
    },
    delCard (id) {
      let that = this
    },
    // 添加
    create (formName) {
      let that = this
      const set = that.$refs
      set[formName].validate(valid => {
        if (valid) {
          getAddclassify(that.form).then(res => {
            that.getSearch()
            that.$message({
              message: '新增成功',
              type: 'success',
              center: true
            })
            that.dialogFormVisible = false
          })
        } else {
          return false
        }
      })
    },
    // 审核
    sureData (formName) {
      let that = this
      that.$refs[formName].validate(valid => {
        if (valid) {
          getRecordAudit(that.form).then(res => {
            that.getSearch(this.listQuery.currentPage)
            that.$message({
              message: '修改成功',
              type: 'success',
              center: true
            })
            that.dialogFormVisible = false
          })
        } else {
          return false
        }
      })
    },
    // 取消
    cancel (formName) {
      this.form.id = ''
      this.dialogFormVisible = false
      this.$refs[formName].resetFields()
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    },
    // 查询对应的列表
    getDetails (id) {
      this.$router.push({
        path: '../demo/punchTheClock',
        query: {
          id: id
        }
      })
    },
    getUser (id) {
      this.$router.push({
        path: '../demo/user/userDetails',
        query: {
          id: id
        }
      })
    }
  }
}
</script>

<style scoped>
::v-deep .el-descriptions-item__label:not(.is-bordered-label) {
  width: 180px;
  border-right: 1px dashed;
  /* padding-left: 50px;
  box-sizing: border-box; */
}
::v-deep .el-descriptions-item__content {
  width: 600px;
  margin-right: 50px;
  display: flex;
  flex-wrap: wrap;
}
.user {
  cursor: pointer;
  color: rgb(64, 158, 255);
}
.demo{
  margin-top: 20px;
  width: 260px;
  margin-right: 20px;
}
</style>
